import { Component, Input } from '@angular/core';

@Component({
    selector: 'accessibility-dashboard-distribution-progress-bar',
    templateUrl: './progress-bar.component.html',
    standalone: false,
})
export class AccessibilityDashboardDistributionProgressBarComponent {
    @Input() checkA: number = 0;
    @Input() checkAa: number = 0;
    @Input() checkAaa: number = 0;
    @Input() total: number = 0;
    @Input() fixed: number = 0;

    calcWidth (input: number): string {
        return parseInt(input.toString()) / this.total * 100 + '%';
    }
}
